// Copy-to-clipboard helper. The old vue-clipboard2 directive was dropped in
// the Vue 3 migration (every v-clipboard usage is commented out) — this is
// the replacement. navigator.clipboard needs a secure context; the
// execCommand fallback covers the Android WebView and older engines.

export async function copyText(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return true
    }
  } catch (e) {
    console.log('navigator.clipboard failed, falling back', e)
  }

  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(textarea)
    return ok
  } catch (e) {
    console.log('execCommand copy failed', e)
    return false
  }
}
